import { Info } from "lucide-react";
import { SwitchComponent } from "../../Atoms";
import { SpecialPermission } from "interfaces";
import { useTranslation } from "react-i18next";

interface SpecialPermissionsProps {
  selectedPermission: number | null;
  specialPermissions: SpecialPermission[];
  permissions: any[];
  onSwitchChange: (
    permissionId: number,
    specialId: number,
    value: boolean
  ) => void;
}
  
export const SpecialPermissions = ({
  selectedPermission,
  specialPermissions,
  permissions,
  onSwitchChange,
}: SpecialPermissionsProps) => {
  const { t } = useTranslation();
  const renderContent = () => {
    if (!selectedPermission) {
      return (
        <div className="text-center py-12 px-4">
          <div className="rounded-full bg-gray-100 w-12 h-12 flex items-center justify-center mx-auto mb-4 dark:bg-zink-700">
            <Info className="w-6 h-6 text-gray-400" />
          </div>
          <h3 className="text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
            {t("AssigmentSpecialPermission.SpecialPermission.noSelect.title")}
          </h3>
          <p className="text-sm text-gray-500 dark:text-gray-400">
            {t(
              "AssigmentSpecialPermission.SpecialPermission.noSelect.description"
            )}
          </p>
        </div>
      );
    }

    if (!specialPermissions || specialPermissions.length === 0) {
      return (
        <div className="text-center py-8 text-gray-500 dark:text-gray-400">
          <div className="rounded-full bg-gray-100 w-12 h-12 flex items-center justify-center mx-auto mb-4 dark:bg-zink-700">
            <Info className="w-6 h-6 text-gray-400" />
          </div>
          <p className="font-medium mb-1">
            {t("AssigmentSpecialPermission.SpecialPermission.error.title")}
          </p>
          <p className="text-sm">
            {t(
              "AssigmentSpecialPermission.SpecialPermission.error.description"
            )}
          </p>
        </div>
      );
    }

    return specialPermissions.map((special) => (
      <div
        key={special.id}
        className="flex items-center justify-between p-4 bg-gray-50 rounded-lg dark:bg-zink-700/50 hover:bg-gray-100 dark:hover:bg-zink-700/80 transition-colors"
      >
        <span className="text-sm text-gray-700 dark:text-gray-200 flex-1 mr-4">
          {special.description}
        </span>
        <SwitchComponent
          isOn={
            permissions.find(
              (p) =>
                p.permissionId === selectedPermission &&
                p.specialPermissionId === special.id
            )?.enabled || false
          }
          onChange={(value) =>
            onSwitchChange(selectedPermission, special.id, value)
          }
          size="small"
        />
      </div>
    ));
  };

  return (
    <div className="md:col-span-3 space-y-4">
      <h3 className="text-sm font-medium text-gray-700 dark:text-gray-200">
        {t("AssigmentSpecialPermission.SpecialPermission.title")}
      </h3>
      <div className="space-y-3 max-h-96 overflow-y-auto pr-2">
        {renderContent()}
      </div>
    </div>
  );
};
